import { Suspense, lazy } from 'react';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Login = Loader(lazy(() => import('src/content/pages/Auth/Login/Cover')));
const ResetPassword = Loader(
  lazy(() => import('src/content/pages/Auth/RecoverPassword'))
);

const authRoutes = [
  {
    path: 'login',
    element: <Login />
  },
  {
    path: 'recover-password',
    element: <ResetPassword />
  }
];

export default authRoutes;
